import { TaskRef } from '@/tracker/types';

/** Поиск на доске и в бэклоге — по ключу и названию среди загруженных задач. Пустой запрос — все */
export const matchesQuery = ({ task, query }: { task: TaskRef; query: string }): boolean => {
  const needle = query.trim().toLowerCase();

  return !needle || `${task.key} ${task.summary}`.toLowerCase().includes(needle);
};
